<template>
    <div class="talent-level-container">
        <div class="box">
            <div class="control">
                <span class="name">用户昵称</span>
                <input type="text" v-model="search.ownerName">
            </div>
            <div class="control">
                <span class="name">画作状态</span>
                <el-select v-model="search.status" placeholder="请选择" style="width: 100px" size="small">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="control">
                <span class="name">创作（更新）时间</span>
                <el-date-picker
                        size="small"
                        v-model="search.startTime"
                        type="datetime"
                        placeholder="放行开始时间"
                        align="right">
                </el-date-picker>
                <span class="r-top">~</span>
                <el-date-picker
                        size="small"
                        v-model="search.endTime"
                        type="datetime"
                        placeholder="放行结束时间"
                        align="right">
                </el-date-picker>
            </div>
            <button class='button is-primary' @click="doSearch">搜索</button>

        </div>
        <div class="list-wrap">
            <div class="clearfix">
                <el-pagination
                        v-if="count>0"
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
            <div class="is-parent clearfix flex">
                <article class="box poster" v-for="(item,index) in list">
                    <div><img style="width: 300px;" :src="item.poster.image" alt=""></div>
                    <div class="clearfix">
                        <span class="fleft name">{{item.ownerName}}</span>
                        <el-button class="fright" v-if="item.status==0" size="small" type="primary" @click="showHideButton(1,index,item.posterId)">显示</el-button>
                        <el-button class="fright" v-else size="small" type="danger" @click="showHideButton(0,index,item.posterId)">隐藏</el-button>
                        <el-button style="margin-right: 10px;" class="fright" size="small" type="primary" @click="onEdit(item)">编辑</el-button>
                    </div>
                    <div>
                        <span class="name fleft">点赞数:</span>
                        <span class="fleft">{{item.virtualPraiseCount}}</span>
                        <span class="fright">{{item.time}}</span>
                    </div>
                </article>
            </div>
            <div class="clearfix">
                <el-pagination
                        v-if="count>0"
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="" :visible.sync="modal.visible" :lock-scroll='false'>
            <div>
                <span>用户名：{{modal.ownerName}}</span>
                <span style="margin-left: 50px;">真实点赞数：{{modal.praiseCount}}</span>
            </div>
            <div style="margin-top: 20px;">
                <el-row :gutter="16">
                      <el-col :span="4">
                          <span>虚拟点赞数：</span>
                      </el-col>
                      <el-col :span="6">
                        <el-input v-model.number="modal.startNum" type="number" size="mini" onblur="minBlur"></el-input>
                      </el-col>
                      <el-col :span="2">
                        ～
                      </el-col>
                      <el-col :span="6">
                        <el-input v-model.number="modal.endNum" type="number" size="mini" onblur="maxBlur"></el-input>
                      </el-col>
                </el-row>
            </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="onCancleEdit">取 消</el-button>
            <el-button type="primary" @click="onConfirmEdit">确 定</el-button>
          </div>
        </el-dialog>
    </div>
</template>
<script type="text/babel">
    import { getTimeByDateStr, formatDate } from 'UTILS/date'

    export default {
        data(){
            return {
                modal: {
                    visible: false,
                    ownerName: '',
                    praiseCount: '',
                    startNum: '',
                    endNum: '',
                },
                search: {
                    page: 1,
                    pageSize: 20,
                    status:-1,
                    startTime:null,
                    endTime:null,
                    ownerName:null,
                },
                list: [],
                count: 0,
                options: [{
                    value: -1,
                    label: '全部'
                }, {
                    value: 0,
                    label: '隐藏'
                }, {
                    value: 1,
                    label: '显示'
                }],
            }
        },
        mounted(){
            this.getList()
        },
        methods: {
            handleCurrentChange(value) {
                if(this.search.page !== value){
                    this.search.page = value
                    this.getList()
                }
            },
            getList(){
                let params = Object.assign({},this.search);
                if(params.startTime){
                    params.startTime = getTimeByDateStr(params.startTime)
                }
                if(params.endTime){
                    params.endTime = getTimeByDateStr(params.endTime)

                }
                HttpRequest.get('/admin.php?method=activityzysadmin.getPosterList', params).then(response => {
                    this.list = _.toArray(response.data.list)
                    this.count = parseInt(response.data.count)

                })
            },
            showHideButton(num,index,id){
                HttpRequest.get('/admin.php?method=activityzysadmin.updatePosterStatus', {posterId:id,status:num}).then(response => {
                    if(num===0){
                        this.list[index].status=0
                    }else{
                        this.list[index].status=1
                    }
                })
            },
            doSearch(){
                this.getList()
            },
            onEdit(_data) {
                this.modal.visible = true;
                this.modal.ownerName = _data.ownerName;
                this.modal.praiseCount = _data.realPraiseCount;
                this.modal.posterId = _data.posterId;
                this.modal.startNum = _data.startNum;
                this.modal.endNum = _data.endNum;
            },
            onCancleEdit() {
                this.modal = {
                    visible: false,
                    ownerName: '',
                    praiseCount: '',
                    startNum: '',
                    endNum: '',
                }
            },
            onConfirmEdit() {
                if (!Number.isInteger(Number(this.modal.startNum)) || Number(this.modal.startNum) < 0) {
                    this.$message('虚拟点赞数起始值必须为正整数！');
                    return false;
                }
                if (!Number.isInteger(Number(this.modal.endNum))  || Number(this.modal.endNum) < 0) {
                    this.$message('虚拟点赞数终值必须为正整数！');
                    return false;
                }
                let params = {
                    posterId: this.modal.posterId,
                    startNum: this.modal.startNum,
                    endNum: this.modal.endNum,
                    type: 1,
                }
                HttpRequest.get('/admin.php?method=activityzysadmin.updateVirtualPraise', params).then(response => {
                    if(response.data.success == 0) {
                        this.$message('操作成功！')
                        this.getList();
                        this.modal = {
                            visible: false,
                            ownerName: '',
                            praiseCount: '',
                            startNum: '',
                            endNum: '',
                        }
                    }
                })
            },
        },
    }
</script>
<style lang="less" scoped>
.poster{
    margin:10px 10px;
}
.name{
    font-weight: bold;
    color: #333;
}
.flex {
    display: flex;
    flex-wrap: wrap;
}
</style>
